var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E80041"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9756 9.24271C16.3214 8.8969 16.8821 8.8969 17.2279 9.24271C17.5737 9.58852 17.5737 10.1492 17.2279 10.495L14.9574 12.7655C14.5669 13.156 14.5669 13.7892 14.9574 14.1797L17.239 16.4613C17.5858 16.808 17.5857 17.3702 17.239 17.7169C16.8923 18.0636 16.3302 18.0636 15.9835 17.7169L13.7019 15.4353C13.3113 15.0448 12.6782 15.0448 12.2876 15.4353L9.99493 17.728C9.64912 18.0738 9.08845 18.0738 8.74264 17.728C8.39683 17.3822 8.39683 16.8215 8.74264 16.4757L11.0354 14.183C11.4259 13.7925 11.4259 13.1593 11.0354 12.7688L8.75375 10.4872C8.40703 10.1405 8.40704 9.57832 8.75375 9.2316C9.10047 8.88488 9.6626 8.88488 10.0093 9.2316L12.2909 11.5132C12.6815 11.9037 13.3146 11.9037 13.7051 11.5132L15.9756 9.24271Z",
    fill: "#FFFBF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#71250A",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBadge);
export default __webpack_public_path__ + "static/media/delete-badge.6949982fe30753a363c9ddd5169d9906.svg";
export { ForwardRef as ReactComponent };